//#region [IMPORT]

// === THIRD-PARTY ===
import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';

import { useTheme } from '@mui/material/styles';
import {
  Box,
} from '@mui/material';

// === COMPONENTS ===
import { Exception } from './components/Exception/Exception';
import { Spacer } from 'components/Spacer';

// === HOOKS ===
import { useAnalytics } from 'pages/DocAnalytics/AnalyticsContext/AnalyticsContext';

//#endregion

//-----------------------------------------------------------------
export function DataPanel() {
  //-----------------------------------------------------------------

  //#region [VALUES]

  const theme = useTheme();

  const { task } = useAnalytics();
  
  const ref = useRef();

  //#endregion

  //#region [STYLES]

  const _styles = {
    field_paper: {
      gridColumn : 'span 4',
      overflow   : 'auto'   ,
      position   : 'relative' ,
      height     : '100%',
      width      : '100%',
      boxShadow  : 0,
      background: theme.palette.background.secondary[theme.palette.mode],
      scrollbarWidth: "thin",
      scrollbarColor: `${theme.palette.primary.main} ${theme.palette.background.secondary[theme.palette.mode]}`,
    }
  }

  const CONTAINER = {
    ref: ref,
    sx : _styles.field_paper,
  }

  //#endregion

  //#region [EFFECT]
  
  

  //#endregion

  //#region [EVENTS]

  //#endregion

  //#region [RENDER]

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    const rules = task?.rules?.order.map( rule_id => {
      const rule = task?.rules?.items[rule_id];
      return <Exception key={rule_id} data={rule}/>
    });

    return (
      <Box { ...CONTAINER }>
          <Spacer size='6px' />
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: '6px' }} >
            {rules}
          </Box>
      </Box>
    );
  }

  //#endregion

  return display();
}